import { useEffect, useContext, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Logout from "./logout";
import { routes, FANMILK, surveyRoutes } from "../../routes";
import logo from "../../assets/images/campaignsLogo.svg";
import CampaignContext from "../../contexts/CampaignContext";
// import CampaignDetailsContext from "../../contexts/CampaignDetailsContext";

// const campaignID = "62834ed429b3cbe224437a3e"; //prod
const campaignID = "62716fbcba13726d1a3f9d07"; //sandbox
const unileverId = "63482f0c29b3cba922b53dbb";
const Sidebar = () => {
  const { pathname } = useLocation();
  const [campaign] = useContext(CampaignContext);
  // const [CampaignDetails] = useContext(CampaignDetailsContext);
  const [campaignId, setCampaignId] = useState("");
  const [CampaignType, setCampaignType] = useState("");

  useEffect(() => {
    const currentCampaign = JSON.parse(sessionStorage.getItem("CAMPAIGN"));
    const currentCampaignDetails = JSON.parse(
      sessionStorage.getItem("CAMPAIGN_DETAILS")
    );
    setCampaignType(currentCampaignDetails?.campaignType);
    setCampaignId(currentCampaign.id);
  }, [campaign]);

  return (
    <div className="text-gray-500 md:shadow-md h-full bg-white">
      <div className="py-1  my-2 pl-7">
        <img
          className="my-3 pl-2 "
          // height="20px"
          src={logo}
          alt="no img"
        />
      </div>
      <div className="mt-8 pt-8">
        <ul className="my-2 text-lg ">
          {campaignId === campaignID || campaignId === unileverId ? (
            <>
              {FANMILK.map((route, index) => (
                <li key={index} className="text-[#848484] text-base">
                  <NavLink
                    to={route.to}
                    className={
                      pathname.includes(route.active)
                        ? "flex items-center py-4 my-2 pl-10 text-[#FF6A3A] font-bold bg-[#FF6A3A1a] border-[#FF6A3A] border-r-4"
                        : "flex items-center text-[#848484] py-4 text-base my-2 pl-10"
                    }
                  >
                    {route.icon}
                    {route.name}
                  </NavLink>
                </li>
              ))}
            </>
          ) : (
            <>
              {CampaignType?.toLowerCase()?.includes("survey") ? (
                <>
                  {" "}
                  {surveyRoutes.map((route, index) => (
                    <li key={index} className="text-[#848484] text-base">
                      <NavLink
                        to={route.to}
                        className={
                          pathname.includes(route.active)
                            ? "flex items-center py-4 my-2 pl-10 text-[#FF6A3A] font-bold bg-[#FF6A3A1a] border-[#FF6A3A] border-r-4"
                            : "flex items-center text-[#848484] py-4 text-base my-2 pl-10"
                        }
                      >
                        {route.icon}
                        {route.name}
                      </NavLink>
                    </li>
                  ))}
                </>
              ) : (
                <>
                  {" "}
                  {routes.map((route, index) => (
                    <li key={index} className="text-[#848484] text-base">
                      <NavLink
                        to={route.to}
                        className={
                          pathname.includes(route.active)
                            ? "flex items-center py-4 my-2 pl-10 text-[#FF6A3A] font-bold bg-[#FF6A3A1a] border-[#FF6A3A] border-r-4"
                            : "flex items-center text-[#848484] py-4 text-base my-2 pl-10"
                        }
                      >
                        {route.icon}
                        {route.name}
                      </NavLink>
                    </li>
                  ))}
                </>
              )}
            </>
          )}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
